import React, { Component } from "react";
import { connect } from "react-redux";
import * as dataActions from "../../../../_actions/dataActions";
import * as searchActions from "../../../../_actions/searchActions";
import FilterWidget from "../../../UI/FilterWidget";
import Slider from "../../../UI/Slider";
import Select from "../../../UI/Select";
import Wrapper from "../../../../_hoc/Wrapper";
import getMaritalStatus from "../../../../_selectors/dataSelectors/getMaritalStatus";
import getMotherTongue from "../../../../_selectors/dataSelectors/getMotherTongue";
import getReligion from "../../../../_selectors/dataSelectors/getReligion";
import getMyGender from "../../../../_selectors/userSelectors/getMyGender";
import getBodyType from "../../../../_selectors/dataSelectors/getBodyType";
import getEducation from "../../../../_selectors/dataSelectors/getEducation";
import getJobType from "../../../../_selectors/dataSelectors/getJobType";
import getIncome from "../../../../_selectors/dataSelectors/getIncome";
import getDiet from "../../../../_selectors/dataSelectors/getDiet";
import getHabitType from "../../../../_selectors/dataSelectors/getHabitType";
import getCountry from "../../../../_selectors/dataSelectors/getCountry";
import getState from "../../../../_selectors/dataSelectors/getState";
class Filter extends Component {
  state = {
    showFilter: true,
    ageStart: 24,
    ageEnd: 27,
    selectedMaritalStatus: [],
    selectedMotherTongue: [],
    selectedReligion: [],
    selectedEducation: [],
    selectedJobType: [],
    selectedIncome: [],
    selectedDiet: [],
    selectedSmoke: [],
    selectedDrink: [],
    selectedCountry: [],
    selectedState: []
  };
  componentDidMount() {
    const {
      maritalStatus,
      getMaritalStatusData,
      motherTongue,
      getMotherTongueData,
      religion,
      getReligionData,
      education,
      jobType,
      income,
      diet,
      habitType,
      getEducationData,
      getJobTypeData,
      getIncomeData,
      getDietData,
      getHabitTypeData,
      country,
      state,
      getCountryData,
      getStateData
    } = this.props;

    if (maritalStatus.length === 0) {
      getMaritalStatusData();
    }
    if (motherTongue.length === 0) {
      getMotherTongueData();
    }
    if (religion.length === 0) {
      getReligionData();
    }
    if (education.length === 0) {
      getEducationData();
    }
    if (income.length === 0) {
      getIncomeData();
    }
    if (jobType.length === 0) {
      getJobTypeData();
    }
    if (diet.length === 0) {
      getDietData();
    }
    if (habitType.length === 0) {
      getHabitTypeData();
    }
    if (country.length === 0) {
      getCountryData();
    }
  }
  toggleShowFilter = () => {
    this.setState(prevState => ({ showFilter: !prevState.showFilter }));
  };
  search = () => {
    const {
      ageEnd,
      ageStart,
      selectedMaritalStatus,
      selectedMotherTongue,
      selectedReligion,
      selectedCountry,
      selectedDiet,
      selectedDrink,
      selectedEducation,
      selectedIncome,
      selectedJobType,
      selectedSmoke,
      selectedState
    } = this.state;
    const { search, isFemale } = this.props;
    search({
      data: {
        ageEnd,
        ageStart,
        maritalStatus: selectedMaritalStatus,
        motherTongue: selectedMotherTongue,
        religion: selectedReligion,
        education: selectedEducation,
        jobType: selectedJobType,
        income: selectedIncome,
        diet: selectedDiet,
        smoke: selectedSmoke,
        drink: selectedDrink,
        isFemale
      }
    });
    this.toggleShowFilter();
  };
  render() {
    const {
      showFilter,
      selectedMaritalStatus,
      selectedMotherTongue,
      selectedReligion,
      ageEnd,
      ageStart,
      selectedCountry,
      selectedDiet,
      selectedDrink,
      selectedEducation,
      selectedIncome,
      selectedJobType,
      selectedSmoke,
      selectedState
    } = this.state;
    const {
      maritalStatus,
      motherTongue,
      religion,
      country,
      state,
      education,
      jobType,
      income,
      diet,
      habitType,
      getStateData
    } = this.props;
    return (
      <FilterWidget
        show={showFilter}
        onToggle={this.toggleShowFilter}
        onSearch={this.search}
      >
        <div className="form-group-one-unit">
          <div className="row">
            <div className="col-sm-12">
              <Slider
                min={21}
                max={80}
                defaultValue={[0, 0]}
                value={[ageStart, ageEnd]}
                label={<Wrapper>Age</Wrapper>}
                multi
                onChange={(start, end) => {
                  this.setState({ ageStart: start, ageEnd: end });
                }}
              />
            </div>
          </div>
          <div className="row">
            <div className="col-sm-4">
              <Select
                label={<Wrapper>Marital Status</Wrapper>}
                selected={selectedMaritalStatus}
                options={maritalStatus}
                onChange={value => {
                  this.setState({ selectedMaritalStatus: value });
                }}
                clearable={false}
                searchable={true}
                placeholder="ANUP"
                multi
              />
            </div>
            <div className="col-sm-4">
              <Select
                label={<Wrapper>Religion</Wrapper>}
                selected={selectedReligion}
                options={religion}
                onChange={value => {
                  this.setState({ selectedReligion: value });
                }}
                clearable={false}
                searchable={true}
                placeholder="ANUP"
                multi
              />
            </div>
            <div className="col-sm-4">
              <Select
                label={<Wrapper>Mother Tongue</Wrapper>}
                selected={selectedMotherTongue}
                options={motherTongue}
                onChange={value => {
                  this.setState({ selectedMotherTongue: value });
                }}
                clearable={false}
                searchable={true}
                placeholder="ANUP"
                multi
              />
            </div>
          </div>
          <div className="row">
            <div className="col-sm-4">
              <Select
                label={<Wrapper>Education</Wrapper>}
                selected={selectedEducation}
                options={education}
                onChange={value => {
                  this.setState({ selectedEducation: value });
                }}
                clearable={false}
                searchable={true}
                placeholder="ANUP"
                multi
              />
            </div>
            <div className="col-sm-4">
              <Select
                label={<Wrapper>Job Type</Wrapper>}
                selected={selectedJobType}
                options={jobType}
                onChange={value => {
                  this.setState({ selectedJobType: value });
                }}
                clearable={false}
                searchable={true}
                placeholder="ANUP"
                multi
              />
            </div>
            <div className="col-sm-4">
              <Select
                label={<Wrapper>Income</Wrapper>}
                selected={selectedIncome}
                options={income}
                onChange={value => {
                  this.setState({ selectedIncome: value });
                }}
                clearable={false}
                searchable={true}
                placeholder="ANUP"
                multi
              />
            </div>
          </div>

          <div className="row">
            <div className="col-sm-4">
              <Select
                label={<Wrapper>Diet</Wrapper>}
                selected={selectedDiet}
                options={diet}
                onChange={value => {
                  this.setState({ selectedDiet: value });
                }}
                clearable={false}
                searchable={true}
                placeholder="ANUP"
                multi
              />
            </div>
            <div className="col-sm-4">
              <Select
                label={<Wrapper>Smoke</Wrapper>}
                selected={selectedSmoke}
                options={habitType}
                onChange={value => {
                  this.setState({ selectedSmoke: value });
                }}
                clearable={false}
                searchable={true}
                placeholder="ANUP"
                multi
              />
            </div>
            <div className="col-sm-4">
              <Select
                label={<Wrapper>Drink</Wrapper>}
                selected={selectedDrink}
                options={habitType}
                onChange={value => {
                  this.setState({ selectedDrink: value });
                }}
                clearable={false}
                searchable={true}
                placeholder="ANUP"
                multi
              />
            </div>
          </div>
          <div className="row">
            <div className="col-sm-6">
              <Select
                label={<Wrapper>Country</Wrapper>}
                selected={selectedCountry}
                options={country}
                onChange={value => {
                  this.setState({ selectedCountry: value }, () => {
                    getStateData(value);
                  });
                }}
                clearable={false}
                searchable={true}
                placeholder="ANUP"
                multi
              />
            </div>
            <div className="col-sm-6">
              <Select
                label={<Wrapper>State</Wrapper>}
                selected={selectedState}
                options={state}
                onChange={value => {
                  this.setState({ selectedState: value });
                }}
                clearable={false}
                searchable={true}
                placeholder="ANUP"
                multi
              />
            </div>
          </div>
        </div>
      </FilterWidget>
    );
  }
}
const mapStateToProps = (state, ownProps) => ({
  maritalStatus: getMaritalStatus(state),
  motherTongue: getMotherTongue(state),
  religion: getReligion(state),
  isFemale: getMyGender(state),
  education: getEducation(state),
  jobType: getJobType(state),
  income: getIncome(state),
  diet: getDiet(state),
  habitType: getHabitType(state),
  country: getCountry(state),
  state: getState(state)
});
const mapDispatchToProps = dispatch => ({
  getMaritalStatusData: () => dispatch(dataActions.getMaritalStatus()),
  getMotherTongueData: () => dispatch(dataActions.getMotherTongue()),
  getReligionData: () => dispatch(dataActions.getReligion()),
  getEducationData: () => dispatch(dataActions.getEducation()),
  getJobTypeData: () => dispatch(dataActions.getJobType()),
  getIncomeData: () => dispatch(dataActions.getIncome()),
  getDietData: () => dispatch(dataActions.getDiet()),
  getHabitTypeData: () => dispatch(dataActions.getHabitType()),
  getCountryData: () => dispatch(dataActions.getCountry()),
  getStateData: country => dispatch(dataActions.getStateByCountry(country)),
  search: payload => dispatch(searchActions.search(payload))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Filter);



// WEBPACK FOOTER //
// ./src/_components/Search/Normal/Filter/index.js